import { render, staticRenderFns } from "./AuthorJinNangIndex.vue?vue&type=template&id=43afcc81&scoped=true&"
import script from "./AuthorJinNangIndex.vue?vue&type=script&lang=js&"
export * from "./AuthorJinNangIndex.vue?vue&type=script&lang=js&"
import style0 from "./AuthorJinNangIndex.vue?vue&type=style&index=0&id=43afcc81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43afcc81",
  null
  
)

export default component.exports